"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _inputZipCode = _interopRequireDefault(require("./input-zip-code.css"));

var InputZipCode = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inheritsLoose2["default"])(InputZipCode, _React$PureComponent);

  function InputZipCode(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.handleClear = _this.handleClear.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateData = _this.updateData.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = InputZipCode.prototype;

  _proto.handleClear = function handleClear() {
    var data = {
      value: '',
      isShowError: false
    };
    this.updateData(data);
  };

  _proto.handleChange = function handleChange(e) {
    var pattern = this.props.pattern;
    var zipCode = e.target.value;
    var isValid = new RegExp(pattern).test(zipCode) || (0, _isEmpty2["default"])(zipCode);
    var data = {
      value: zipCode,
      isShowError: !isValid
    };
    this.updateData(data);
  };

  _proto.updateData = function updateData(data) {
    var onChange = this.props.onChange;
    onChange(data);
  };

  _proto.render = function render() {
    var _clsx;

    var _this$props = this.props,
        id = _this$props.id,
        testID = _this$props['data-testid'],
        label = _this$props.label,
        className = _this$props.className,
        inputClassName = _this$props.inputClassName,
        errorMessage = _this$props.errorMessage,
        name = _this$props.name,
        theme = _this$props.theme,
        value = _this$props.value,
        isShowError = _this$props.isShowError;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx2["default"])(_inputZipCode["default"].inputContainer, className)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: id,
      className: (0, _clsx2["default"])(_inputZipCode["default"].label, (_clsx = {}, _clsx[_inputZipCode["default"].labelFocused] = !!value, _clsx))
    }, label), /*#__PURE__*/_react["default"].createElement("input", {
      "data-testid": testID,
      id: id,
      className: (0, _clsx2["default"])(_inputZipCode["default"].input, isShowError && _inputZipCode["default"].inputError, inputClassName),
      name: name,
      onChange: this.handleChange,
      value: value
    }), isShowError && /*#__PURE__*/_react["default"].createElement("p", {
      className: _inputZipCode["default"].errorMessage
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _clsx2["default"])(theme.mmcIconFormError, _inputZipCode["default"].errorMessageIcon)
    }), ' ', errorMessage), value && /*#__PURE__*/_react["default"].createElement("button", {
      className: (0, _clsx2["default"])(theme.grey, _inputZipCode["default"].clearBtn),
      "aria-label": "Clear button",
      type: "button",
      onClick: this.handleClear
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: theme.mmcIconClose
    })));
  };

  return InputZipCode;
}(_react["default"].PureComponent);

exports["default"] = InputZipCode;
InputZipCode.defaultProps = {
  onChange: function onChange() {
    return undefined;
  }
};